import { Tab, Tabs } from "@mui/material";
import { observer } from "mobx-react";
import React from "react";
import type ResearchFindingStore from "./ResearchFindingStore";
import { QUESTION_FILTERS } from "./ResearchFindingStore";

type Props = {
    store: ResearchFindingStore;
};

/** Question filter tabs with counts. */
const QuestionFilterTabs: React.FC<Props> = observer(({ store }) => {
    return (
        <Tabs
            value={store.activeFilter}
            onChange={(_, value) => store.setFilter(value)}
            variant="scrollable"
            scrollButtons="auto"
            sx={{ minHeight: "40px" }}
        >
            {QUESTION_FILTERS.map((filter) => (
                <Tab
                    key={filter}
                    value={filter}
                    label={`${filter} (${store.filterCounts[filter]})`}
                    sx={{ minHeight: "40px", textTransform: "none" }}
                />
            ))}
        </Tabs>
    );
});

export default QuestionFilterTabs;
